import Login from "./LoginLayout/Login";
import { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Home from "./pages/Home";
import ShopData from "./pages/ShopData";
import Register from "./LoginLayout/Register";

export default function PrivateRoute() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) {
      navigate("/login");
    } else {
      setToken(storedToken);
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="App">
      {token ? (
        <Routes>
          <Route path="/" element={<Home />}>
            <Route path="/shop" element={<ShopData />} />
          </Route>
        </Routes>
      ) : (
        <Navigate to="/login " replace />
      )}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </div>
  );
}
